import React, {Component} from 'react';
import PropTypes from 'prop-types';
import AddressAutocomplete from 'react-google-autocomplete';
import _ from 'lodash';
import defaultCallback from 'lib/defaultCallback';

export class InputText extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputId: !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('input')),
            value: this.props.defaultValue || '',
            hasErrors: false,
            errors: [],
            showHelper: false
        };
        this._onChange = this._onChange.bind(this);
        this.clearErrors = this.clearErrors.bind(this);
        this.addError = this.addError.bind(this);
        this.setError = this.setError.bind(this);
        this.setValue = this.setValue.bind(this);
    }

    _onChange(event) {
        if (!!this.props.onBeforeChange) {
            this.props.onBeforeChange(event.target.value);
        }
        this.setState({ value: event.target.value });
        if (!!this.props.clearErrorOnChange) {
            this.clearErrors();
        }
        if (!!this.props.onAfterChange) {
            this.props.onAfterChange(event.target.value);
        }
    }

    setWordlessError() {
        this.setState({
            hasErrors: true,
            errors: []
        });
    }

    clearErrors(callback) {
        this.setState({
            hasErrors: false,
            errors: []
        }, callback);
    }

    addError(error, callback) {
        let errorComponent = <span key={_.uniqueId('error')}>{error}</span>;
        this.state.errors.push(errorComponent);
        this.setState({
            hasErrors: true,
            errors: this.state.errors
        }, callback);
    }

    setError(error, callback) {
        this.state.errors = [];
        this.addError(error, callback);
    }

    setValue(newValue) {
        this.setState({ value: newValue });
        document.getElementById(this.state.inputId).value = newValue;
    }

    getValue() {
        return document.getElementById(this.state.inputId).value
    }

    static addComma(nStr)
        {
            nStr+="";
            let x = nStr.split('.');
            let x1 = x[0];
            let x2 = x.length > 1 ? '.' + x[1] : "";
            let rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        }


    toggleHelper(value) {
        this.setState({showHelper: value})
    }

    render() {
        const {
            inputType,
            className,
            label,
            hasLabelFor,
            maxLength,
            name,
            defaultValue,
            onFocus,
            inputProps,
            textHelper
        } = this.props;

        const {
            inputId,
            hasErrors,
            showHelper,
            errors
        } = this.state;

        return (
            <div className={`input-wrapper input-type-${inputType} ${hasErrors ? 'error' : ''} ${className || ''}`}>
                <label htmlFor={hasLabelFor ? inputId : null }>{label}</label>
                <input
                    type={inputType}
                    name={name}
                    id={inputId}
                    placeholder={label}
                    onChange={this._onChange}
                    defaultValue={defaultValue}
                    maxLength={maxLength ? maxLength : null}
                    onFocus={onFocus} {...inputProps} />
                {
                    // please notice this scope is currently used only for InputTel. if you want to use texthelper for other things,
                    // make sure you update this.state.showHelper too.
                    textHelper && (showHelper || inputType === 'tel') ? <p className="text-helper">{textHelper}</p> : null
                }
                <div className="errors">{errors}</div>
            </div>
        )
    }
}
InputText.propTypes = {
    inputType: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    name: PropTypes.string,
    maxLength: PropTypes.string,
    validator: PropTypes.func.isRequired
};
InputText.defaultProps = {
    inputType: 'text',
    label: '',
    name: '',
    validator: defaultCallback
};




export class InputPassword extends InputText {
    constructor(props) {
        super(props);
        this.state.inputId = !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('password'));//!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('password');
    }
}
InputPassword.propTypes = Object.assign({}, InputText.propTypes);
InputPassword.defaultProps = Object.assign({}, InputText.defaultProps, {inputType: 'password'});




export class InputHidden extends InputText {
    constructor(props) {
        super(props);
        this.state.inputId = !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('hidden'));
        // this.state.inputId = !!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('hidden');
    }
}
InputHidden.propTypes = Object.assign({}, InputText.propTypes);
InputHidden.defaultProps = Object.assign({}, InputText.defaultProps, {inputType: 'hidden'});




export class InputTel extends InputText {
    constructor(props) {
        super(props);
        this.state.inputId = !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('tel'));
        // this.state.inputId = !!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('tel');
    }
}
InputTel.propTypes = Object.assign({}, InputText.propTypes);
InputTel.defaultProps = Object.assign({}, InputText.defaultProps, {inputType: 'tel'});




export class InputNumber extends InputText {
    constructor(props) {
        super(props);
        this.state.inputId = !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('number'));
    }
}
InputNumber.propTypes = Object.assign({}, InputText.propTypes);
InputNumber.defaultProps = Object.assign({}, InputText.defaultProps, {inputType: 'number'});



export class InputEmail extends InputText {
    constructor(props) {
        super(props);
        this.state.inputId = !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('email'));
        // this.state.inputId = !!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('email');
    }
}
InputEmail.propTypes = Object.assign({}, InputText.propTypes);
InputEmail.defaultProps = Object.assign({}, InputText.defaultProps, {inputType: 'email'});




export class InputSelect extends InputText {
    constructor(props) {
        super(props);
        this.state.inputId = !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('select'));
        this.state.value = !!this.props.defaultValue ? this.props.defaultValue : Object.keys(this.props.options)[0];
    }

    render() {
        let options = [];
        for (let k in this.props.options) {
            let v = this.props.options[k];
            options.push(<option key={k} value={k} disabled={this.state.value && !k ? true : false}>{v}</option>);
        }
        return (
            <div className={`input-wrapper input-type-${this.props.inputType} ${this.state.hasErrors ? 'error' : ''} ${this.props.className || ''}`}>
                <label htmlFor={this.props.hasLabelFor === false ? null :this.state.inputId}>{this.props.label}</label>
                <select className={this.state.value ? 'has-value' : ''} data-value={this.state.value} value={this.state.value} type={this.props.inputType} name={this.props.name} id={this.state.inputId} onChange={this._onChange} onClick={this.props.onClick} {...this.props.inputProps}>
                    { options }
                </select>
                <div className="errors">{this.state.errors}</div>
            </div>
        );
    }
}
InputSelect.propTypes = Object.assign(
    {},
    InputText.propTypes,
    {
        options: PropTypes.object
    }
);
InputSelect.defaultProps = Object.assign(
    {},
    InputText.defaultProps,
    {
        inputType: 'select',
        options: {}
    }
);



export class InputRadio extends InputText {
    constructor(props) {
        super(props);
        this.state.inputId = !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('radio'));
        this.state.value = !!this.props.defaultValue ? this.props.defaultValue : null;
    }

    render() {
        const options = [];
        for (let k in this.props.options) {
            const key = k.replace(/number/g, '');
            options.push(
                <label key={key} >
                    <input type="radio" value={key} name={this.props.name} onChange={(event)=>{this._onChange(event)}} checked={this.state.value === key} onClick={e => {typeof this.props.onClick === 'function' && this.props.onClick(e)}} />
                    {this.props.options[k]}
                    {this.props.options[k] == this.props.showTooltip && this.props.tooltip}
                </label>
            );
        }
        return (
            <div className={`input-wrapper input-type-${this.props.inputType} ${this.state.hasErrors ? 'error' : ''} ${this.props.className || ''}`}>
                <label>{this.props.label}</label>
                { options }
                <div className="errors">{this.state.errors}</div>
            </div>
        );
    }
}
InputRadio.propTypes = Object.assign(
    {},
    InputText.propTypes,
    {
        options: PropTypes.object
    }
);
InputRadio.defaultProps = Object.assign(
    {},
    InputText.defaultProps,
    {
        inputType: 'radio',
        options: {}
    }
);



export class InputTextArea extends InputText {
    constructor(props) {
        super(props);
        this.state.inputId = !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('textarea'));
    }

    render() {
        return (
            <div className={`input-wrapper input-type-${this.props.inputType} ${this.state.hasErrors ? 'error' : ''} ${this.props.className || ''}`}>
                <label htmlFor={this.props.hasLabelFor === false ? null :this.state.inputId}>{this.props.label}</label>
                <textarea className={this.state.value ? 'has-value' : ''} name={this.props.name} id={this.state.inputId} placeholder={this.props.label} defaultValue={this.props.defaultValue} onChange={this._onChange} {...this.props.inputProps} />
                <div className="errors">{this.state.errors}</div>
            </div>
        )
    }
};
InputTextArea.propTypes = Object.assign({}, InputText.propTypes);
InputTextArea.defaultProps = Object.assign({}, InputText.defaultProps, {inputType: 'textarea'});


//AddressAutocomplete
export class InputAddressAutocomplete extends InputText {
    constructor(props) {
        super(props);
        this.state.inputId = !!this.props.inputId ? this.props.inputId : (!!this.props.name ? _.uniqueId(this.props.name) : _.uniqueId('address-autocomplete'));
    }

    render() {
        return (
            <div className={`input-wrapper input-type-${this.props.inputType} ${this.state.hasErrors ? 'error' : ''} ${this.props.className || ''}`}>
                <label htmlFor={this.props.hasLabelFor === false ? null :this.state.inputId}>{this.props.label}</label>
                <AddressAutocomplete type="text" className={this.state.value ? 'has-value' : ''} name={this.props.name}
                                     id={this.state.inputId} placeholder={this.props.label}
                                     defaultValue={this.props.defaultValue}
                                     onChange={this._onChange}
                                     onPlaceSelected={(place)=>{this._onChange({target:{value:place.formatted_address}});}}
                                     types={['address']}
                                     componentRestrictions={{country: "us"}}
                                     {...this.props.inputProps}/>
                <div className="errors">{this.state.errors}</div>
            </div>
        )
    }
};
InputAddressAutocomplete.propTypes = Object.assign({}, InputText.propTypes);
InputAddressAutocomplete.defaultProps = Object.assign({}, InputText.defaultProps, {inputType: 'address-autocomplete'});
